import { getAuthToken, removeAuthToken } from "../../helpers";
import { REFRESH_TOKEN } from "../constants";
// for a user to be considered logged in, they must have both a refresh token and an auth token
export var isLoggedIn = function () {
    var _a, _b;
    var authToken = getAuthToken();
    if (typeof window === "undefined") {
        return !!authToken;
    }
    var refreshToken = (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(REFRESH_TOKEN);
    if (!!authToken && !!refreshToken) {
        return true;
    }
    // if user has only 1 or the other, remove them to set user to fully logged out.
    if (!!authToken || !!refreshToken) {
        removeAuthToken();
        (_b = window === null || window === void 0 ? void 0 : window.localStorage) === null || _b === void 0 ? void 0 : _b.removeItem(REFRESH_TOKEN);
    }
    return false;
};
